// extracted by mini-css-extract-plugin
module.exports = {"small":"styles_small__uh403","imageOverlay":"styles_imageOverlay__fHDiN","title":"styles_title__BgKVf","blackscience":"styles_blackscience__O3c5t","sport":"styles_sport__2Z4VL"};